import { CanDeactivateFn } from '@angular/router';

export interface PendingChangesComponent {
  confirmLeaveWithUnsavedChanges(): boolean;
}

export const pendingChangesGuard: CanDeactivateFn<PendingChangesComponent> = (component) => {
  return component.confirmLeaveWithUnsavedChanges();
};

